import { googleFetch } from '../client';

export interface GoogleDriveUser {
  displayName?: string;
  emailAddress?: string;
  photoLink?: string;
}

export interface GoogleDriveStorageQuota {
  usage?: string;
  usageInDrive?: string;
  limit?: string;
}

export interface GoogleDriveAboutResponse {
  user?: GoogleDriveUser;
  storageQuota?: GoogleDriveStorageQuota;
  maxUploadSize?: string;
  folderColorPalette?: string[];
}

export async function googleDriveAboutGet(): Promise<GoogleDriveAboutResponse> {
  return googleFetch<GoogleDriveAboutResponse>('/rpc/google_drive_about_get');
}
